import debounce from 'lodash/debounce'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { compose, mapProps, withHandlers } from 'recompose'
import withNormalizeValue from 'components/common/hoc/withNormalizeValue'
import reduxForm from 'components/common/hoc/withFormErrorFocus'
import { DEBOUNCE_INTERVAL } from 'constant'
import { handleChooseAddressSuggestion } from './actions'
import createPersonalInformationFormViewModel from './createPersonalInformationFormViewModel'
import PersonalInformationForm from './PersonalInformationForm'
import withAddressSuggestions from './withAddressSuggestions'
import { PERSONAL_INFORMATION_FORM } from './constants'
import validate from './validate'

const withHandleOptionsFetch = withHandlers({
  handleOptionsFetch: ({ fetchAddresses }) => debounce(fetchAddresses, DEBOUNCE_INTERVAL)
})

const withFormModel = mapProps(({
  addresses: addressSuggestions, resetAddresses, stateOptions, monthOptions, dayOptions, formValues, ...props
}) => ({
  ...props,
  model: createPersonalInformationFormViewModel({
    addressSuggestions,
    stateOptions,
    monthOptions,
    dayOptions,
    formValues,
    resetAddresses
  })
}))

export default compose(
  withAddressSuggestions,
  withHandleOptionsFetch,
  reduxForm({
    form: PERSONAL_INFORMATION_FORM,
    validate
  }),
  connect(state => ({
    formValues: getFormValues(PERSONAL_INFORMATION_FORM)(state)
  }), { handleChooseAddressSuggestion }),
  withNormalizeValue,
  withFormModel
)(PersonalInformationForm)
